import React from 'react';
import PropTypes from 'prop-types';
import Chip from 'Chip';
import Slides from '@ifeng/ui_pc_slides';
import styles from './index.css';
import errorBoundary from '@ifeng/errorBoundary';
import { handleAd } from '@ifeng/ui_pc_ad';
import { getRecommandSlides } from '../../../../../services/api';

let flag = 0;

class RecommendSlide extends React.PureComponent {
    static propTypes = {
        recommendData: PropTypes.array,
        base62Id: PropTypes.string,
        searchPath: PropTypes.string,
        adData: PropTypes.object,
        isFo: PropTypes.bool,
    };

    state = {
        recommendData: this.props.recommendData,
    };

    ref = React.createRef();

    async componentDidMount() {
        const { recommendData } = this.state;
        const { base62Id, searchPath } = this.props;

        if (recommendData.length === 0) {
            try {
                const data = await getRecommandSlides(searchPath.replace(/[, ].*/, ''), base62Id);

                this.setState(
                    {
                        recommendData: data,
                    },
                    async () => {
                        const { infoAd5 } = this.props.adData;

                        try {
                            const callbackFn = await handleAd(infoAd5);

                            callbackFn(this.ref.current, infoAd5.data);
                        } catch (e) {
                            console.error(e);
                        }
                    },
                );
            } catch (e) {
                console.error(e);
            }
        }
    }

    sliderTmpl = list => {
        flag++;

        return (
            <div className={styles.slideItem}>
                {list && list.length > 0
                    ? list.map((item, index) => (
                          <a
                              href={item.url}
                              key={index}
                              className={styles.link}
                              imgindex={index}
                              title={item.title}
                              ref={(flag === 2 || flag === 7) && index === 4 ? this.ref : ''}>
                              <img src={item.thumbnail} width="180px" height="122px" />
                              <div className={styles.title} title={item.title}>
                                  {item.title}
                              </div>
                          </a>
                      ))
                    : ''}
            </div>
        );
    };

    sliderTmplFo = list => {
        return (
            <div className={styles.slideItem}>
                {list && list.length > 0
                    ? list.map((item, index) => (
                          <a href={item.url} key={index} className={styles.link} imgindex={index} title={item.title}>
                              <img src={item.thumbnail} width="180px" height="122px" />
                              <div className={styles.title} title={item.title}>
                                  {item.title}
                              </div>
                          </a>
                      ))
                    : ''}
            </div>
        );
    };

    render() {
        let { recommendData } = this.state;
        const { isFo } = this.props;

        if (!(recommendData instanceof Array)) {
            recommendData = [];
        }

        // channelTitle根据不同频道进行，匹配数据
        const newList = [recommendData.slice(0, 5), recommendData.slice(5, 10), recommendData.slice(10)];
        const config = {
            arrows: false,
            dotsAction: 'hover',
            autoplay: true,
            autoplayInterval: 6000,
            speed: 1000,
            sliderTmpl: !isFo ? this.sliderTmpl : this.sliderTmplFo,
            dotStyle: styles.dot,
            dotCurrentStyle: styles.current,
        };

        if (isFo) {
            return (
                <Chip id="60057" type="recommend" title="上推广" groupName="正文" content={recommendData}>
                    <div className={styles.container}>
                        <div className={styles.box}>
                            <Slides content={newList} config={config} />
                        </div>
                    </div>
                </Chip>
            );
        } else if (recommendData.length === 15) {
            return (
                <div className={styles.container}>
                    <div className={styles.box}>
                        <Slides content={newList} config={config} />
                    </div>
                </div>
            );
        }

        return '';
    }
}

export default errorBoundary(RecommendSlide);
